import { RHFRadioField } from '@openx/components-core/lib/RadioField/RHFRadioField';
import type { RadioOptionType } from '@openx/components-core/lib/RadioField/types';
import type { TFunction } from 'i18next';
import { useMemo } from 'react';
import { type FieldArrayWithId, type Path, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { RevenueMethod } from '../../AudienceForm/constants';
import type { AudienceForm } from '../../AudienceForm/types';

export const getRadioOptions = (
  t: TFunction
): RadioOptionType<AudienceForm['audience_share'][number]['revenue_method']>[] => [
  {
    label: t('Percentage of Media'),
    value: 'PoM',
  },
  {
    label: t('Fixed CPM'),
    value: 'CPM',
  },
];

type RevenueMethodRadioProps = {
  itemIndex: number;
  field: FieldArrayWithId<AudienceForm, 'audience_share', 'id'>;
};

export const RevenueMethodRadio = ({ itemIndex, field }: RevenueMethodRadioProps) => {
  const { t } = useTranslation();
  const { setValue, trigger, getValues } = useFormContext<AudienceForm>();

  const radioOptions = useMemo(() => getRadioOptions(t), [t]);
  const radioFieldName = `audience_share.${itemIndex}.revenue_method` satisfies Path<AudienceForm>;
  const inputValue = getValues(`audience_share.${itemIndex}.value` satisfies Path<AudienceForm>);

  return (
    <RHFRadioField
      name={radioFieldName}
      options={radioOptions}
      data-test="revenue-method-label"
      row
      fullWidth
      sx={{ mt: 2 }}
      onChange={(event, value) => {
        event.preventDefault();
        field.revenue_method = value as RevenueMethod;
        setValue(radioFieldName, value as RevenueMethod, { shouldDirty: true, shouldTouch: true });

        if (inputValue) {
          trigger(`audience_share.${itemIndex}.value` satisfies Path<AudienceForm>);
        }
      }}
    />
  );
};
